export default __webpack_public_path__ + "static/media/overlap-mobile.159367e5.png";